
const homeIcon = <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
<g clip-path="url(#clip0_194_8565)">
<path d="M4.84779 8.11118C5.09448 9.06964 5.96453 9.77785 7 9.77785C8.03547 9.77785 8.90552 9.06964 9.15221 8.11118M6.45428 1.86897L2.68633 4.7996C2.43446 4.9955 2.30852 5.09345 2.21779 5.21611C2.13743 5.32477 2.07756 5.44718 2.04113 5.57733C2 5.72426 2 5.8838 2 6.20289V10.2223C2 10.8446 2 11.1557 2.1211 11.3934C2.22763 11.6025 2.39761 11.7724 2.60668 11.879C2.84436 12.0001 3.1555 12.0001 3.77778 12.0001H10.2222C10.8445 12.0001 11.1556 12.0001 11.3933 11.879C11.6024 11.7724 11.7724 11.6025 11.8789 11.3934C12 11.1557 12 10.8446 12 10.2223V6.20289C12 5.8838 12 5.72426 11.9589 5.57733C11.9224 5.44718 11.8626 5.32477 11.7822 5.21611C11.6915 5.09345 11.5655 4.9955 11.3137 4.7996L7.54573 1.86897C7.35054 1.71716 7.25295 1.64126 7.14519 1.61208C7.05011 1.58634 6.94989 1.58634 6.85481 1.61208C6.74705 1.64126 6.64946 1.71716 6.45428 1.86897Z" stroke="#94A3B8" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</g>
<defs>
<clipPath id="clip0_194_8565">
<rect width="13.3333" height="13.3333" fill="white" transform="translate(0.333008 0.333008)"/>
</clipPath>
</defs>
</svg>
export const routes = [
    { path: "/", label: homeIcon },
    { path: "/smarttest", label: "Akilli Test" },
    { path: "/smarttest/subject/mode", label: "Test Modu Seçin" },
    { path: "/smarttest/lesson/mode", label: "Test Modu Seçin" },
    { path: "/smarttest/random/mode", label: "Test Modu Seçin" },
    { path: "/smarttest/random/mode/start", label: "Teste Başlamaya Hazırlanın"},

  ];
  